export default __webpack_public_path__ + "static/media/MDI - chevron-down.db835fb0.svg";